import React from 'react'

const Footer = () => {
    return (
        <div className="footer">
            <h4>
                copyright &copy; {new Date().getFullYear()} HOME & AWAY
            </h4>
            <small className="layo">Developed By @LayoBright &#128526;</small>
        </div>
    )
}

export default Footer
